export const colorBaseBlack = "rgb(15, 15, 20)";
export const colorBaseWhite = "rgb(255, 255, 255)";